export default __webpack_public_path__ + "static/media/avatar.2c91e879.png";